<template>
  <div class="headerTop" :key="keyItem">
    <img src="../assets/image/log.png" alt="" class="logo" />
    <div class="nav">
      <div
        :class="['item', item.index == button ? 'active' : '']"
        v-for="(item, key) in navList"
        :key="key"
        @click="navGetTo(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "headerTop",
  data() {
    return {
      navList: [
        {
          name: "首页",
          index: "1",
          path: "/",
        },
        {
          name: "钱湖柏庭",
          index: "2",
          path: "/Home",
        },
        {
          name: "柏庭荟",
          index: "3",
          path: "/Meeting",
        },
        {
          name: "五有服务",
          index: "4",
          path: "/Service",
        },
        {
          name: "联系我们",
          index: "5",
          path: "/About",
        },
      ],
      button: "1",
      keyItem:0,
    };
  },
  methods: {
    navGetTo(item) {
      this.button = item.index;
      // this.$store.state.button=item.index;
      sessionStorage.setItem("button", item.index);
      this.$router.push({ path: item.path });
    },
  },
  mounted: function () {
    this.button = sessionStorage.getItem("button");
    
  },
  components: {},
  watch: {
    $route: {
      handler(newRouter) {
     
        this.keyItem+=1;
        if (newRouter.matched[0].path == "") {
          this.button = "1";

          sessionStorage.setItem("button", "1");
        } else if (newRouter.matched[0].path == "/Home") {
          this.button = "2";

          sessionStorage.setItem("button", "2");
        } else if (newRouter.matched[0].path == "/Meeting") {
          this.button = "3";

          sessionStorage.setItem("button", "3");
        } else if (newRouter.matched[0].path == "/Service") {
          this.button = "4";

          sessionStorage.setItem("button", "4");
        } else if (newRouter.matched[0].path == "/About") {
          this.button = "5";

          sessionStorage.setItem("button", "5");
        }
      },
    },
  },
};
</script>
  <style  scoped="scoped">
.headerTop {
  width: 100%;
  height: 1.25rem;
  background: rgba(64, 104, 75, 0.8);
  padding: 0.25rem 1.75rem;
  text-align: left;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999999;
}
.logo {
  width: 3.375rem;
  height: 0.625rem;
  margin-right: 1.9375rem;
}
.nav {
  min-width: 9.375rem;
  height: 100%;

  font-size: 0.375rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  display: flex;
}
.item {
  padding: 0.1625rem 0.4rem;
  display: inline-block;
  border-radius: 0.125rem;
  margin-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.item:hover {
  background-color: #ffffff;
  color: #40684c;
}
.active {
  background-color: #ffffff;
  color: #40684c;
}
</style>